import { apiClient } from './client'
import type { Quote, PaginatedResponse } from '../types'

export interface QuoteWithSnippet extends Quote {
  snippet?: string
}

export interface FTSResponse extends PaginatedResponse<QuoteWithSnippet> {}

export interface AISearchResponse {
  items: Quote[]
  explanations: Record<string, string>
  query: string
}

export interface AIKeyStatus {
  configured: boolean
  provider: string
}

export const searchApi = {
  fts: (q: string, page = 1, pageSize = 20) =>
    apiClient.get<FTSResponse>('/search/fts', { params: { q, page, page_size: pageSize } }),

  ai: (q: string) =>
    apiClient.get<AISearchResponse>('/search/ai', { params: { q } }),

  getAIKeyStatus: () =>
    apiClient.get<AIKeyStatus>('/search/ai-key'),

  saveAIKey: (key: string) =>
    apiClient.put<AIKeyStatus>('/search/ai-key', { key }),

  deleteAIKey: () =>
    apiClient.delete<AIKeyStatus>('/search/ai-key'),
}
